import { TermsPage } from '@/app/pages/TermsPage';

export function ResponsiveTermsPage() {
  return <TermsPage />;
}
